/**
 * Replaced at build time by `define` in `vite.config.ts`. The `typeof` guard
 * below keeps this module importable from Node-side config, which needs
 * `DEV_APP_VERSION` but never has the define in scope.
 */
declare const __APP_VERSION__: string | undefined

/**
 * Stands in for a release id when the build could not resolve one. Only a local
 * `pnpm serve` reaches it — CI and image builds supply `APP_VERSION`, and a
 * checkout falls back to its git SHA. RouteReloader treats it as "no version"
 * so a dev build never prompts itself to reload.
 */
export const DEV_APP_VERSION = 'development'

/**
 * The release compiled into this bundle. The build writes the same value to
 * `/version.json`, so the two only differ once a newer build is serving.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'undefined' ? DEV_APP_VERSION : __APP_VERSION__
